const STATUS_MAP = {
  unscheduled: { label: "Unscheduled", classes: "bg-slate-100 text-slate-700 ring-slate-200" },
  scheduled: { label: "Scheduled", classes: "bg-blue-100 text-blue-800 ring-blue-200" },
  in_progress: { label: "In Progress", classes: "bg-orange-100 text-orange-800 ring-orange-200" },
  done: { label: "Complete", classes: "bg-green-100 text-green-800 ring-green-200" },
  draft: { label: "Draft", classes: "bg-slate-100 text-slate-700 ring-slate-200" },
  sent: { label: "Sent", classes: "bg-blue-100 text-blue-800 ring-blue-200" },
  paid: { label: "Paid", classes: "bg-green-100 text-green-800 ring-green-200" },
  approved: { label: "Approved", classes: "bg-green-100 text-green-800 ring-green-200" },
  rejected: { label: "Rejected", classes: "bg-red-100 text-red-800 ring-red-200" },
};

export default function StatusBadge({ status, className = "" }) {
  const s = STATUS_MAP[status] || { label: status, classes: "bg-slate-100 text-slate-700 ring-slate-200" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ring-1 ring-inset ${s.classes} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {s.label}
    </span>
  );
}

export function UrgencyFlag({ urgency }) {
  if (urgency === "emergency") {
    return (
      <span data-testid="urgency-flag-emergency" className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-bold bg-red-600 text-white">
        <span className="h-1.5 w-1.5 rounded-full bg-white animate-pulse" />
        EMERGENCY
      </span>
    );
  }
  if (urgency === "urgent") {
    return (
      <span data-testid="urgency-flag-urgent" className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-bold bg-amber-100 text-amber-800 ring-1 ring-inset ring-amber-200">
        URGENT
      </span>
    );
  }
  return null;
}
